export const PauseIcon: React.FC = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="16" fill="#089BFF" />
    <path d="M12 11H15V21H12V11ZM17 11H20V21H17V11Z" fill="white" />
  </svg>
);
